// this mimics Task.NodeType in the backend
enum EventType {
  ASSIGNEE = 'assignee',
  COMPONENT = 'Component',
  DESCRIPTION = 'description',
  DUEDATE = 'duedate',
  EPIC_LINK = 'Epic Link',
  ESTIMATE = 'Story point estimate',
  ISSUE_PARENT_ASSOCIATION = 'IssueParentAssociation',
  ISSUETYPE = 'issuetype',
  LABELS = 'labels',
  POINTS = 'Story Points',
  PRIORITY = 'priority',
  REPORTER = 'reporter',
  RESOLUTION = 'resolution',
  SPRINT = 'Sprint',
  STATUS = 'status',
  SUMMARY = 'summary',
  TIME_ESTIMATE = 'timeestimate',
  TIME_ORIGINAL_ESTIMATE = 'timeoriginalestimate',
}

type EventGraphPayload = {
  project_id: string | null;
  board_id: string | null;
  work_period_id: string | null;
  task_types: string | null;
  epic_id: string | null;
  task_id: string | null;
  workflow_id: string | null;
  start_date: string;
  end_date: string;
  statuses: string;
};

type EventGraphEdgeTasksPayload = EventGraphPayload & {
  edge_id: string;
};

type EventGraphNode = {
  id: string;
  label: string;
  event_type: EventType;
  sequence: number;
};

type EventGraphEdge = {
  source: string;
  target: string;
  weight: number;
  task_count: number;
  percentage: number;
  cycle_time: number;
  cost: number;
};

type EventGraph = {
  nodes: EventGraphNode[];
  edges: EventGraphEdge[];
};

export { EventType };
export type { EventGraph, EventGraphEdge, EventGraphEdgeTasksPayload, EventGraphNode, EventGraphPayload };
